'use strict';

export const OPEN_SUPPORT_SISP = 'support/OPEN_SUPPORT_SISP';
export const CLOSE_SUPPORT_SISP = 'support/CLOSE_SUPPORT_SISP';